<template>
	<v-sheet elevation="0">
		<v-row no-gutters>
			<v-col :class="!$vuetify.breakpoint.mdAndUp ? '' : 'pr-2'" cols="12" md="6">
				<div class="mt-4">
					<label class="text-body-2 font-weight-bold">企業共通情報</label>
					<v-radio-group
						v-model="shareInfoOption"
						row
						:hide-details="!shareInfoOption || shareInfoOption != 'none'"
						@change="changeShareInfoOption"
					>
						<v-radio value="none" label="登録しない" class="mr-2 mt-1" dense />
						<v-radio value="search" label="既存データから選択する" class="mr-2 mt-1" dense />
						<v-radio value="add" label="新しく登録する" class="mr-2 mt-1" dense />
					</v-radio-group>
				</div>
				<div class="mt-2" v-if="shareInfoOption == 'search'">
					<v-combobox
						label="企業共通情報"
						v-model="customer_company.customer_company_share_info_id"
						:items="customer_company_share_infos"
						item-text="name"
						item-value="id"
						no-data-text="企業共通情報がありません"
						class="mt-4"
						outlined
						dense
						clearable
						@change="deleteAddedValue"
					/>
				</div>
				<div class="mt-2 pb-4" v-else-if="shareInfoOption == 'add'">
					<CustomerCompanyShareInfoDialog
						:customer_company_share_info.sync="customerCompanyShareInfo"
					/>
				</div>

				<v-text-field
					label="顧客企業名・拠点名（必須）"
					v-model="customer_company.name"
					dense
					outlined
					:rules="[rules.required]"
					class="mt-4"
				/>
				<v-text-field
					label="顧客企業名・拠点名（フルネーム）"
					v-model="customer_company.full_name"
					dense
					outlined
					class="mt-4"
				/>
				<v-text-field
					label="得意先コード"
					v-model="customer_company.customer_code"
					dense
					outlined
					class="mt-4"
				/>
				<v-select
					label="業種"
					v-model="customer_company.industry_id"
					:items="industries"
					item-text="name"
					item-value="id"
					no-data-text="業種情報がありません"
					class="mt-4"
					outlined
					clearable
					dense
				/>
				<v-text-field
					label="代表電話番号"
					v-model="customer_company.phone"
					dense
					outlined
					class="mt-4"
				/>
				<v-text-field
					label="代表FAX番号"
					v-model="customer_company.fax"
					dense
					outlined
					class="mt-4"
				/>
				<v-text-field
					label="代表メールアドレス"
					:rules="[rules.emailFormat]"
					v-model="customer_company.email"
					type="email"
					dense
					outlined
					class="mt-4"
				/>
				<v-autocomplete
					label="締め日"
					v-model="customer_company.cutoff_date"
					:items="cutoffDates"
					:item-text="'name'"
					:item-value="'id'"
					no-data-text="締め日データが見つかりませんでした。"
					dense
					outlined
					class="mt-4"
				/>
			</v-col>
			<v-col :class="!$vuetify.breakpoint.mdAndUp ? '' : 'pl-2'" cols="12" md="6">
				<v-text-field
					label="郵便番号"
					v-model="customer_company.zipcode"
					dense
					outlined
					class="mt-4"
				/>
				<v-autocomplete
					v-model="customer_company.prefecture"
					label="都道府県"
					class="mt-4"
					outlined
					dense
					no-data-text="データが見つかりませんでした。"
					:items="prefectures"
				/>
				<v-text-field
					v-model="customer_company.city"
					label="市区町村"
					class="mt-4"
					outlined
					dense
				/>
				<v-textarea
					class="mt-4"
					label="住所"
					v-model="customer_company.address"
					outlined
					dense
					rows="2"
				/>
				<v-textarea
					class="mt-4"
					label="建物名・部屋番号"
					v-model="customer_company.building"
					outlined
					dense
					rows="2"
				/>
				<div class="mt-4">
					<v-row no-gutters>
						<v-combobox
							ref="tagComboBox"
							label="タグ"
							v-model="tag"
							:items="tags"
							item-text="name"
							item-value="id"
							no-data-text="タグがありません"
							outlined
							dense
							:hint="tagHint"
							@keyup="setSearchTags"
							@change="changeTag"
						/>
						<v-btn icon class="ml-2" @click="createTag"
							><v-icon>mdi-plus-circle-outline</v-icon></v-btn
						>
					</v-row>
					<v-chip-group>
						<v-chip
							v-for="tag in customer_company.customer_company_tag_ids"
							class="ma-0 mr-2"
							:key="tag.id"
							close
							color="primary"
							outlined
							@click:close="deleteTag(tag.id)"
						>
							{{ tag.name }}
						</v-chip>
					</v-chip-group>
				</div>
				<div class="mt-4">
					<v-row no-gutters justify="space-between">
						<h6 class="text-h6 font-weight-bold">社員情報</h6>
						<v-row no-gutters justify="end">
							<v-btn color="secondary" @click="addCustomerPerson">
								<v-icon class="mr-2">mdi-account-multiple-plus-outline</v-icon>
								社員情報を登録する</v-btn
							>
						</v-row>
					</v-row>
					<div v-if="filteredArray(customer_company.customer_people_attributes).length">
						<CustomerPersonDialog
							v-for="(customerPerson, i) in filteredArray(
								customer_company.customer_people_attributes
							)"
							:key="customerPerson.uuid"
							:customer_person="filteredArray(customer_company.customer_people_attributes)[i]"
							@delete-customer-person="deleteCustomerPerson(i)"
							@change-customer-person="changeCustomerPerson($event, i)"
						/>
					</div>
					<template v-else>
						<p class="text-body-2">登録された社員情報がありません。</p>
					</template>
				</div>
				<div class="mt-4">
					<v-row no-gutters justify="space-between">
						<h6 class="text-h6 font-weight-bold">メモ</h6>
						<v-row no-gutters justify="end">
							<v-btn color="secondary" @click="addMemo">
								<v-icon class="mr-2">mdi-text-box-plus-outline</v-icon>
								メモを追加する</v-btn
							>
						</v-row>
					</v-row>
					<div v-if="filteredArray(customer_company.memos_attributes).length">
						<template v-for="(memo, i) in filteredArray(customer_company.memos_attributes)">
							<MemoShowDialog
								v-if="memo.user_id && memo.user_id != $store.getters['auth/authData'].id"
								:key="memo.uuid"
								:memo_data="filteredArray(customer_company.memos_attributes)[i]"
							/>
							<MemoDialog
								v-else
								:key="memo.uuid"
								:memo_data="filteredArray(customer_company.memos_attributes)[i]"
								@delete-memo="deleteMemo(i)"
								@change-memo="changeMemo($event, i)"
							/>
						</template>
					</div>
					<template v-else>
						<p class="text-body-2">追加されたメモがありません。</p>
					</template>
				</div>
			</v-col>
		</v-row>
	</v-sheet>
</template>

<script>
import axios from "axios"
import Qs from "qs"
import rules from "../../../helper/rules"
import authenticate from "../../../helper/authenticate"
import errorHandling from "../../../helper/errorHandling"
import CustomerCompanyShareInfoDialog from "./CustomerCompanyShareInfoDialog.vue"
import CustomerPersonDialog from "./CustomerPersonDialog.vue"
import MemoDialog from "../../shared/MemoDialog.vue"
import MemoShowDialog from "../../shared/MemoShowDialog.vue"

export default {
	props: {
		customer_company_data: {
			type: Object,
			required: true,
			default: () => ({}),
		},
		customer_company_share_info: {
			type: Object,
			required: true,
			default: () => ({}),
		},
		industries: {
			type: Array,
			required: false,
			default: () => [],
		},
		cutoffDates: {
			type: Array,
			required: true,
		},
		customer_company_share_infos: {
			type: Array,
			required: false,
			default: () => [],
		},
	},
	components: {
		CustomerCompanyShareInfoDialog,
		CustomerPersonDialog,
		MemoDialog,
		MemoShowDialog,
	},
	data() {
		return {
			rules: rules,
			shareInfoOption: "none",
			prefectures: this.$store.state.prefectures,
			tag: null,
			tags: [],
			errorMessageFlag: false,
			errorMessages: [],
			searchTagsTimer: null,
			tagKeyword: null,
		}
	},
	methods: {
		deleteAddedValue(item) {
			if (!this.customer_company_share_infos.includes(item)) {
				this.customer_company.customer_company_share_info_id = null
			}
		},
		addCustomerPerson() {
			const newCustomerPerson = {
				uuid: this.newUuid(),
				name: null,
				name_kana: null,
				birth_day: null,
				gender: null,
				position: null,
				phone: null,
				fax: null,
				email: null,
				department: null,
			}
			this.customer_company.customer_people_attributes.push(newCustomerPerson)
		},
		addMemo() {
			const newMemo = {
				uuid: this.newUuid(),
				content: null,
				files: [],
			}
			this.customer_company.memos_attributes.push(newMemo)
		},
		changeCustomerPerson(customerPerson, i) {
			const child = this.filteredArray(this.customer_company.customer_people_attributes)[i]
			const index = this.customer_company.customer_people_attributes.indexOf(child)
			this.$set(this.customer_company.customer_people_attributes, index, customerPerson)
		},
		changeMemo(memo, i) {
			const child = this.filteredArray(this.customer_company.memos_attributes)[i]
			const index = this.customer_company.memos_attributes.indexOf(child)
			this.$set(this.customer_company.memos_attributes, index, memo)
		},
		deleteCustomerPerson(i) {
			this.deleteChildForm(this.customer_company.customer_people_attributes, i)
		},
		deleteMemo(i) {
			this.deleteChildForm(this.customer_company.memos_attributes, i)
		},
		deleteChildForm(array, i) {
			const child = this.filteredArray(array)[i]
			const index = array.indexOf(child)
			if (child.id) {
				array.push({
					id: child.id,
					_destroy: true,
				})
			}
			array.splice(index, 1)
		},
		changeShareInfoOption() {
			if (this.shareInfoOption != "add") {
				this.customerCompanyShareInfo = {
					name: null,
					capital: null,
					establishment_date: null,
					employees_number: null,
					representative: null,
					representative_kana: null,
					website: null,
				}
			} else if (this.shareInfoOption != "search") {
				this.customer_company.customer_company_share_info_id = null
			}
		},
		changeTag() {
			if (this.tags.includes(this.tag)) {
				this.addTag(this.tag)
				this.tags = []
			}
		},
		setSearchTags(e) {
			if (e.key == "ArrowDown" || e.key == "ArrowUp") return
			this.tags = []
			this.tagKeyword = e.target.value
			clearTimeout(this.searchTagsTimer)
			if (!this.tagKeyword.length) return
			this.searchTagsTimer = setTimeout(this.fetchTags, 500)
		},
		createTag() {
			const headers = authenticate.setHeader()
			axios
				.post(
					"/erp/v1/customer_companies/customer_company_tags",
					{
						customer_company_tag: { name: this.tagKeyword },
					},
					{ headers }
				)
				.then((res) => {
					this.addTag(res.data)
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		addTag(tag) {
			this.$refs.tagComboBox.reset()
			if (!this.customer_company.customer_company_tag_ids.filter((t) => t.id == tag.id).length) {
				this.customer_company.customer_company_tag_ids.push(tag)
			} else {
				this.$store.dispatch("setFlash", {
					type: "alert",
					text: "既にタグは選択されています。",
				})
			}
		},
		deleteTag(id) {
			this.customer_company.customer_company_tag_ids =
				this.customer_company.customer_company_tag_ids.filter((tag) => tag.id != id)
		},
		fetchTags() {
			const params = {
				q: {
					name_cont: this.tagKeyword,
					id_not_in: this.customer_company.customer_company_tag_ids.map((t) => t.id),
				},
			}
			const paramsSerializer = (params) => Qs.stringify(params, { arrayFormat: "brackets" })
			const headers = authenticate.setHeader()
			axios
				.get("/erp/v1/customer_companies/customer_company_tags", {
					headers,
					params,
					paramsSerializer,
				})
				.then((res) => {
					this.searchTagsTimer = null
					this.tags = res.data
					this.errorMessageFlag = false
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		newUuid() {
			return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
				(c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
			)
		},
	},
	computed: {
		filteredArray() {
			return (array) => {
				return array.filter((attribute) => !attribute._destroy)
			}
		},
		tagHint() {
			if (this.tags.length) {
				return "タグを選択してください"
			} else if (this.searchTagsTimer) {
				return "タグを検索しています"
			} else if (!this.tags.length && this.tagKeyword) {
				return "該当するタグが存在していません"
			} else {
				return "タグ名を入力してください"
			}
		},
		customer_company: {
			get() {
				return this.customer_company_data
			},
			set(newVal) {
				return this.$emit("update:customer_company_data", newVal)
			},
		},
		customerCompanyShareInfo: {
			get() {
				return this.customer_company_share_info
			},
			set(newVal) {
				return this.$emit("update:customer_company_share_info", newVal)
			},
		},
	},
}
</script>